module.exports = __webpack_public_path__ + "static/img/1_1.14c6e0fb.jpg";